// Only allow web/mail schemes so a stored link can never be a javascript:/data: XSS vector.
export const safeUrl = (url) => {
  const u = (url || "").trim();
  if (!u) return null;
  const low = u.toLowerCase();
  if (low.startsWith("http://") || low.startsWith("https://") || low.startsWith("mailto:")) return u;
  return null;
};
